import { Doughnut, mixins } from 'vue-chartjs';
import { Loading } from 'element-ui';
import api from '@/api';
import * as ChartColors from '@/util/chartColors';
import ReportData from '@/mixin/ReportData';

const { reactiveData } = mixins;

export default {
  name: 'EBDistributionChart',
  extends: Doughnut,
  mixins: [reactiveData, ReportData],
  props: {
    priorYear: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      options: {
        responsive: true,
        maintainAspectRatio: false,
        legend: {
          position: 'left',
        },
        title: {
          display: true,
          text: 'Early Bird Breakdown',
        },
        animation: {
          animateScale: true,
          animateRotate: true,
        },
      },
    };
  },
  mounted() {
    this.renderChart(this.chartData, this.options);
    this.fetchData();
  },
  methods: {
    fetchData() {
      const loadingInstance = Loading.service({
        target: this.$el,
      });
      api.report.getEarlyBirdDistribution(this.dateRange, this.forOffice, this.priorYear).then((result) => {
        this.buildDataset(result.data);
      }).finally(() => {
        this.$nextTick(() => {
          loadingInstance.close();
        });
      });
    },
    buildDataset(results) {
      const enrolled = results.enrolled;
      const qualified = results.qualified;
      const dnq = results.dnq;

      const total = enrolled + qualified + dnq;
      const enrolledPercentage = this.calcPercentage(enrolled, total);
      const qualifiedPercentage = this.calcPercentage(qualified, total);
      const dnqPercentage = this.calcPercentage(dnq, total);

      this.chartData = {
        labels: [
          `Enrolled ${enrolledPercentage}`,
          `Qualified (not Enrolled) ${qualifiedPercentage}`,
          `Did Not Qualify ${dnqPercentage}`,
        ],
        datasets: [
          {
            data: [
              enrolled,
              qualified,
              dnq,
            ],
            backgroundColor: [
              ChartColors.getRGBA(ChartColors.GREEN),
              ChartColors.getRGBA(ChartColors.BLUE),
              ChartColors.getRGBA(ChartColors.RED),
            ],
          },
        ],
      };
    },
  },
};
